export const TRANSLATIONS = {
    EN: {
        THANK_YOU: {
            CONTINUE: 'Continue to process',
            IDENTIFICATION: {
                TITLE: 'Thank you for completing the identification.',
            },
            SIGNING: {
                TITLE: 'Thank you for signing the Power of Attorney.',
            },
            SUBSCRIPTION: {
                TITLE: 'Thank you for subscribing',
                DESCRIPTION: 'Thank you for the payment of the director salary administration. The director salary administration will now automatically be renewed annually.',
            },
        },
    },
    NL: {
        THANK_YOU: {
            CONTINUE: 'Doorgaan naar procedure',
            IDENTIFICATION: {
                TITLE: 'Bedankt voor het voltooien van de identificatie.',
            },
            SIGNING: {
                TITLE: 'Bedankt voor het ondertekenen van de volmacht.',
            },
            SUBSCRIPTION: {
                TITLE: 'Bedankt voor het abonneren',
                DESCRIPTION: 'Bedankt voor de betaling voor de dga salaris adiministratie. De DGA salarisadministratie zal nu automatisch jaarlijks worden verlengd.',
            },
        },
    },
};
